import { Navigate } from 'react-router-dom';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  FOOTBALL_PLAY,
  LANDING,
} from '@sorare/core/src/constants/__generated__/routes';
import useIsLoggedIn from '@sorare/core/src/hooks/auth/useIsLoggedIn';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { HeroVideo } from './HeroVideo';
import { Howto } from './Howto';
import { Needsyou } from './Needsyou';
import { Pick } from './Pick';
import { Win } from './Win';

const Wrapper = styled(Vertical)`
  /** necessary for the ribon that add a scroll bar becore of its slight rotation */
  overflow: hidden;
  gap: calc(10 * var(--unit));
`;

const Kylianmbappe = () => {
  const {
    flags: { useMbappeLanding = false },
  } = useFeatureFlags();
  const isLoggedIn = useIsLoggedIn();
  if (!useMbappeLanding) {
    return <Navigate to={LANDING} />;
  }
  if (isLoggedIn) {
    return <Navigate to={FOOTBALL_PLAY} />;
  }
  return (
    <Wrapper>
      <HeroVideo />
      <Needsyou />
      <Howto />
      <Win />
      <Pick />
    </Wrapper>
  );
};
export default Kylianmbappe;
